(async () => {
  var e = await import(window.theme.modules.baseComponent);
  customElements.define(
    "product-price",
    class extends e.default {
      render() {
        this.listenTo("variantChange", (e, t) => {
          this._update(t.html), (this.style.display = "block");
        }),
          this.listenTo("sellingPlanChange", (e, t) => {
            this._update(t.html);
          });
      }

      _update(e) {
        const t = e.querySelector("product-price");
        this.replaceChildren(...t.cloneNode(!0).childNodes);
      }
    }
  );
})();
